//@ts-ignore
import { tw } from "@careinfo/tailwind";

const TextField = (props: any) => {
  const {
    placeholder,
    value,
    register,
    type = "text",
    errors,
    label,
    disabled = false,
    min,
    max,
  } = props;

  return (
    <div className={tw`w-full text-left mt-1`}>
      <label>{label}</label>
      <input
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        defaultValue={value}
        {...register}
        type={type}
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        {...(type === "number" && {
          min,
          max,
        })}
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default TextField;
